import { render, staticRenderFns } from "./AreaCascader.vue?vue&type=template&id=3a77177d&scoped=true&"
import script from "./AreaCascader.vue?vue&type=script&lang=js&"
export * from "./AreaCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77177d",
  null
  
)

export default component.exports